import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Outlet from "./Outlet";

@Model()
class OutletAddress extends ApplicationRecord {
  static jsonapiType = "outlet_addresses";

  @Attr() address: Record<string, string>;

  @Attr() defaultFlag: boolean;

  @BelongsTo() outlet: Outlet;
}

export default OutletAddress;
